import CustomProcessingContent from "@/components/desktop/modal/CustomProcessingContent";
import useProcessingStore from "@/stores/useProcessingStore";

import styles from "@/components/desktop/modal/custom-processing-modal.module.scss";

const GlobalProcessingOverlay = () => {
	const isProcessing = useProcessingStore((state) => state.isProcessing);
	const message = useProcessingStore((state) => state.message);

	if (!isProcessing) {
		return null;
	}

	return (
		<div className={styles.overlay}>
			<div className={styles.modal}>
				<CustomProcessingContent message={message} />
			</div>
		</div>
	);
};

export default GlobalProcessingOverlay;
